import { Button, ColorIcon, colors, customEvent, HStack, VStack } from "goi_common";

interface RequestQuestionUniqueStepButtonsProps {
  onOpen: () => void;
}

export const RequestQuestionUniqueStepButtons = ({
  onOpen,
}: RequestQuestionUniqueStepButtonsProps) => {
  return (
    <VStack gap={10}>
      <Button
        style={{
          borderRadius: 16,
          backgroundColor: colors.orange100,
          padding: "6px 14px",
          boxShadow: "2px 2px 2px #00000022",
        }}
        onClick={() => {
          customEvent({
            newGtm: {
              path: "parlor_detail_request",
              trigger_and_target: "quick_cnslt-opn_urgnt_mdl",
            },
          });
          onOpen();
        }}
      >
        <HStack alignItems="center" gap={10}>
          <ColorIcon name="icon-call-mono" color={colors.orange650} width={12} height={12} />
          <div className="caption_12_sb orange700">빠른 상담</div>{" "}
          <ColorIcon name="icon-arrow-right-small-mono" color={colors.orange700} size={8} />
        </HStack>
      </Button>

      <Button
        style={{
          borderRadius: 16,
          backgroundColor: colors.orange100,
          padding: "6px 14px",
          boxShadow: "2px 2px 2px #00000022",
        }}
        onClick={() => {
          customEvent({
            newGtm: {
              path: "parlor_detail_request",
              trigger_and_target: "chat",
            },
          });
          window.open("http://pf.kakao.com/_xgFDaK/chat");
        }}
      >
        <HStack alignItems="center" gap={10}>
          <ColorIcon name="chat_bubble_rounded" color={colors.orange650} width={12} height={12} />
          <div className="caption_12_sb orange700">채팅 상담</div>{" "}
          <ColorIcon name="icon-arrow-right-small-mono" color={colors.orange700} size={8} />
        </HStack>
      </Button>
    </VStack>
  );
};
